/* eslint-disable max-lines */

import { RSAA, getJSON } from 'redux-api-middleware';
import {
  getEvidenceUrl,
  getQueryStringValueByName,
  validateRouteToRedirect,
  getPayload
} from '../../utils';
import { getBackNavigationRoute } from '../../utils/headerUtil';
import moment from 'moment';
import { selectors as caseSelector } from '../../infrastructure/cases';
import Html2Canvas from 'html2canvas';
import {
  ROUTE_PERSONAL_INFO_PAGE,
  ROUTE_USERNAME_PASSWORD_PAGE,
  NAVIGATE_TO_CD,
  METHOD_POST,
  METHOD_PUT,
  CREATE_CUSTOMERS_CASE,
  CREATE_CUSTOMERS_CASE_SUCCESS,
  REDIRECT_TO_ACCOUNT_DETAILS,
  CREATE_CUSTOMERS_CASE_FAILED,
  ROUTE_ADDITIONAL_PRODUCT_PAGE,
  ROUTE_REVIEW_PAGE,
  CASE_ID,
  NAVIGATE_TO_BD,
  API_VERSION,
  ROUTE_ACCOUNT_DETAILS_PAGE,
  NAVIGATE_TO_CD_REVIEW,
  NAVIGATE_TO_BD_REVIEW,
  ACCESS_TOKEN,
  UPDATE_DETAILS_CASE,
  UPDATE_DETAILS_CASE_SUCCESS,
  UPDATE_DETAILS_CASE_FAILED,
  REDIRECT_ADDITIONAL_PRODUCT_PAGE,
  ROUTE_INFO_SECTION,
  SCREEN_SHOT_MIME_TYPE,
  SCREEN_SHOT_QUALITY,
  API_STRING_FIELD_MAX_LENGTH,
  INFO_FLAG,
  CASE_SUBTYPE,
  OFFER_PAGE,
  LETTER_CODE,
  DECLINE,
  OFFER_CASE_ID,
  ROUTE_TECH_ERROR,
  NAVIGATE_TO_IMP_INFO,
  ROUTE_INITIAL_QUESTION_PAGE,
  ROUTE_IDV_QUESTION_PAGE,
  ROUTE_CREDIT_CHECK_REFERRED_NO_MATCH_PAGE,
  ROUTE_DEFERRED_PAGE,
  ROUTE_PENDING_STATEMENTS_PAGE,
  ROUTE_PENDING_STATEMENTS_FAIL_PAGE,
  SET_UP_IN_PROGRESS_ERROR,
  SAVE_AND_RESUME_CAPTURE,
  CASE_TYPE_NTB,
  CASE_TYPE_EXISTING,
  ROUTE_BUSINESS_MANDATE_PAGE,
  ROUTE_ENTER_LINK_CODE,
  ROUTE_TO_INCORRECT_LINK_CODE,
  ROUTE_PERSONAL_DETAILS_PAGE,
  ROUTE_PRIMARY_APPLICANT_WAITING,
  ROUTE_SECONDARY_APPLICANT_WAITING,
  ROUTE_SIGNIFICANT_PEOPLE_PAGE,
  ROUTE_SIGNATORIES_AND_SHAREHOLDERS_PAGE,
  ROUTE_DOCUMENT_VERSION_PAGE,
  NAVIGATE_TO_EXIT,
  REDIRECT_TO_PAGE,
  LINK_CODE_KEY,
  ROUTE_TO_IDV_CHALLENGE_ERROR,
  ROUTE_CHECK_IDENTITY_PAGE,
  ROUTE_BEGIN_YOUR_APPLICATION_PAGE,
  FULLMENT_INPROGRESS,
  ROUTE_APPLICATION_COMPLETE_PAGE,
  BRAND_ID,
  NAVIGATION_BACK,
  APPLICANT_FLOW,
  ROUTE_SWITCH_DATE_PAGE
} from '../../utils/constants';

import {
  createCasePayload,
  updateCasePayload,
  updateAdditonalPayload,
  getSubmitBody
} from './payloads';
import { retrieveOffers, getNextCall, FROM_OFFER_FLOW } from '../../infrastructure/offers';
import { redirectBasesOnTaskUri } from '../../infrastructure/offers/action.helper';
import { ERROR_CODES, ERROR_CODE_325, ERROR_CODE_326 } from '../../utils/errorCodes';
import { addOfficer, updateOfficer } from '../../infrastructure/officer';
import { redirectToSignificantPeoplePage } from '../../infrastructure/config';
import { FROM_CAS_FLOW } from '../../infrastructure/oldSignatories';
import { resetConfirmSwitchError } from '../../infrastructure/oldSignatories';

export const SAVE_INITIAL_QUESTIONS_FORM = 'SAVE_INITIAL_QUESTIONS_FORM';
export const SAVE_ENTER_LINK_CODE_FORM = 'SAVE_ENTER_LINK_CODE_FORM';
export const SAVE_PERSONAL_INFORMATION_FORM = 'SAVE_PERSONAL_INFORMATION_FORM';
export const SAVE_BUSINESS_TYPE_FORM = 'SAVE_BUSINESS_TYPE_FORM';
export const SAVE_BUSINESS_MANDATE_PAGE = 'SAVE_BUSINESS_MANDATE_PAGE';
export const REDIRECT_ERROR_PAGE = 'REDIRECT_ERROR_PAGE';
export const SAVE_BUSINESS_MANDATE_FORM = 'SAVE_BUSINESS_MANDATE_FORM';
export const SAVE_SIGNATORIES_AND_SHAREHOLDERS_FORM = 'SAVE_SIGNATORIES_AND_SHAREHOLDERS_FORM';
export const SAVE_SIGNIFICANT_PEOPLE_FORM = 'SAVE_SIGNIFICANT_PEOPLE_FORM';
export const SAVE_USERNAME_PASSWORD_FORM = 'SAVE_USERNAME_PASSWORD_FORM';
export const SAVE_ADDITIONAL_PRODUCTS_FORM = 'SAVE_ADDITIONAL_PRODUCTS_FORM';
export const SAVE_REVIEW_SECTIONS_FORM = 'SAVE_REVIEW_SECTIONS_FORM';
export const SAVE_ACCOUNT_DETAILS_PAGE = 'SAVE_ACCOUNT_DETAILS_PAGE';
export const SAVE_ENTER_AUTH_FORM = 'SAVE_ENTER_AUTH_FORM';
export const SAVE_OPEN_BUSINESS_ACCOUNT_FORM = 'SAVE_OPEN_BUSINESS_ACCOUNT_FORM';
export const SAVE_ALT_BUSINESS_ACCOUNT_FORM = 'SAVE_ALT_BUSINESS_ACCOUNT_FORM';
export const PAYMENT_TYPE_CHECKBOX_CHECKED = 'PAYMENT_TYPE_CHECKBOX_CHECKED';
export const REDIRECT_TO_REVIEW_PAGE = 'REDIRECT_TO_REVIEW_PAGE';
export const SAVE_DETAILS_FORM = 'SAVE_DETAILS_FORM';
export const SAVE_CHECK_IDENTITY_FORM = 'SAVE_CHECK_IDENTITY_FORM';
export const SAVE_SECURITY_CHECKS_FORM = 'SAVE_SECURITY_CHECKS_FORM';
export const SUBMIT_CASE_ID_FORM = 'SUBMIT_CASE_ID_FORM';
export const SUBMIT_CASE_ID_FORM_SUCCESS = 'SUBMIT_CASE_ID_FORM_SUCCESS';
export const SUBMIT_CASE_ID_FORM_FAILED = 'SUBMIT_CASE_ID_FORM_FAILED';
export const SUBMIT_EVIDENCE_FORM = 'SUBMIT_EVIDENCE_FORM';
export const SUBMIT_EVIDENCE_SUCCESS = 'SUBMIT_EVIDENCE_SUCCESS';
export const SUBMIT_EVIDENCE_FAILED = 'SUBMIT_EVIDENCE_FAILED';
export const SAVE_EVIDENCE_TYPE_FORM = 'SAVE_EVIDENCE_TYPE_FORM';
export const SUBMIT_IMAGE_SERVICE_CALL = 'SUBMIT_IMAGE_SERVICE_CALL';
export const GET_OFFER = 'GET_OFFER';
export const GET_OFFER_SUCCESS = 'GET_OFFER_SUCCESS';
export const GET_OFFER_FAILED = 'GET_OFFER_FAILED';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED';
export const REDIRECT_TOLETTER_CODE = 'REDIRECT_TOLETTER_CODE';
export const GET_OFFERS_CALL = 'GET_OFFERS_CALL';
export const REDIRECT_TO_DECLINE_PAGE = 'REDIRECT_TO_DECLINE_PAGE';
export const ERROR_PAGE = 'ERROR_PAGE';
export const SAVE_INITIAL_PAGES_SCREEN = 'SAVE_INITIAL_PAGES_SCREEN';
export const REDIRECT_TO_INITIAL_PAGE = 'REDIRECT_TO_INITIAL_PAGE';
export const REDIRECT_IDV_QUESTION = 'REDIRECT_IDV_QUESTION';
export const TOGGLE_APP_LOADER = 'TOGGLE_APP_LOADER';
export const SAVE_PERSONAL_DETAILS = 'SAVE_PERSONAL_DETAILS';
export const REDIRECT_ADD_SHAREHOLDER = 'REDIRECT_ADD_SHAREHOLDER';
export const SAVE_OFFICER_DETAILS = 'SAVE_OFFICER_DETAILS';
export const REQUEST_LINK_CODE_SCREEN = 'REQUEST_LINK_CODE_SCREEN';
export const REDIRECT_TO_LINK_CODE = 'REDIRECT_TO_LINK_CODE';
export const REDIRECT_TO_DOC_VERSION_PAGE = 'REDIRECT_TO_DOC_VERSION_PAGE';
export const VALIDATE_LINK_AND_REDIRECT = 'VALIDATE_LINK_AND_REDIRECT';

export const NAVIGATE_TP_BUSINESSTYPE_ON_BACK = 'NAVIGATE_TP_BUSINESSTYPE_ON_BACK';
export const REDIRECT_TO_BUSINESS_MANDATE_PAGE = 'REDIRECT_TO_BUSINESS_MANDATE_PAGE';
export const SAVE_ACCOUNT_DETAILS_VALUES = 'SAVE_ACCOUNT_DETAILS_VALUES';
export const ON_ACCOUNT_DETAILS_CHANGE = 'ON_ACCOUNT_DETAILS_CHANGE';
export const ON_COUNTRY_REMOMVE = 'ON_COUNTRY_REMOMVE';
export const RESET_LINK_CODE_ERROR = 'RESET_LINK_CODE_ERROR';
export const SUBMIT_EVIDENCE_INFO_FORM = 'SUBMIT_EVIDENCE_INFO_FORM';
export const SUBMIT_EVIDENCE_INFO_SUCCESS = 'SUBMIT_EVIDENCE_INFO_SUCCESS';
export const SUBMIT_EVIDENCE_INFO_FAILED = 'SUBMIT_EVIDENCE_INFO_FAILED';

export const saveImportantInformationForm = (fromFlow, isPrimaryEdit) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/current/${getQueryStringValueByName(
      CASE_ID
    ) || getQueryStringValueByName(OFFER_CASE_ID)}/tasks/capture/actions/submit`,
    method: 'PUT',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: state => getSubmitBody(state),
    types: [
      {
        type: SUBMIT_CASE_ID_FORM,
        meta: {
          loading: isPrimaryEdit ? true : fromFlow === FROM_OFFER_FLOW
        }
      },
      {
        type: SUBMIT_CASE_ID_FORM_SUCCESS,
        meta: { nextAction: getNextCall(true), loading: false }
      },
      {
        type: SUBMIT_CASE_ID_FORM_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

//Route for ImportantInfo
export const submitImageServiceCall = (image, subtype) => ({
  [RSAA]: {
    endpoint: getEvidenceUrl(subtype, getCaseId()),
    method: 'POST',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: () => createEvidenceRequestBody(image),
    types: [
      {
        type: SUBMIT_EVIDENCE_FORM,
        meta: {
          loading: true
        }
      },
      {
        type: SUBMIT_EVIDENCE_SUCCESS,
        meta: (_action, state) => ({
          nextAction: caseSelector.getJointLinkCode(state)
            ? redirectToSignificantPeoplePage()
            : routeToImportantInfoPage(),
          loading: false
        })
      },
      {
        type: SUBMIT_EVIDENCE_FAILED,
        meta: () => ({
          nextAction: routeToImportantInfoPage(),
          loading: false
        })
      }
    ]
  }
});
/**
 * Image Service Call for Update
 */
export const submitImageInfoServiceCall = (image, subtype, fromFlow, isPrimaryEdit) => ({
  [RSAA]: {
    endpoint: getEvidenceUrl(subtype, getCaseId()),
    method: 'POST',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: () => createEvidenceRequestBody(image, fromFlow),
    types: [
      {
        type: 'SUBMIT_EVIDENCE_INFO_FORM',
        meta: {
          loading: isPrimaryEdit
            ? true
            : fromFlow === FROM_OFFER_FLOW || fromFlow === FROM_CAS_FLOW,
          isFromPage: !isPrimaryEdit && fromFlow !== FROM_OFFER_FLOW
        }
      },
      {
        type: 'SUBMIT_EVIDENCE_INFO_SUCCESS',
        meta: () => checkForOfferFLow(fromFlow, isPrimaryEdit)
      },
      {
        type: 'SUBMIT_EVIDENCE_INFO_FAILED',
        meta: () => checkForOfferFLow(fromFlow, isPrimaryEdit)
      }
    ]
  }
});

/**
 * This will take screenshot by using Html2Canvas
 */
const takeScreenshot = (_data, subtype, info, isPrimaryEdit) => {
  return dispatch =>
    Html2Canvas(document.getElementById('rootEl')).then(canvas => {
      const screenshot = canvas.toDataURL(SCREEN_SHOT_MIME_TYPE, SCREEN_SHOT_QUALITY);
      let imageStrValue = screenshot;
      const parts = [];

      if (typeof imageStrValue !== 'string' || imageStrValue.length === 0) {
        return parts;
      }
      const numParts = Math.ceil(imageStrValue.length / API_STRING_FIELD_MAX_LENGTH);
      for (let i = 0; i < numParts; i++) {
        parts.push(imageStrValue.substr(0, API_STRING_FIELD_MAX_LENGTH));
        imageStrValue = imageStrValue.substr(API_STRING_FIELD_MAX_LENGTH);
      }
      if (info === INFO_FLAG || info === FROM_OFFER_FLOW || info === FROM_CAS_FLOW) {
        dispatch(sendImageInfoServiceCall(parts, subtype, info, isPrimaryEdit));
      } else {
        dispatch(sendImageServiceCall(parts, subtype));
      }
    });
};

/**
 * This will create request body to send image to Service
 * @param {*} screenImage
 */
const createEvidenceRequestBody = (screenImage, fromFlow) => {
  const requestData = {
    context: fromFlow !== FROM_CAS_FLOW ? SAVE_AND_RESUME_CAPTURE : FULLMENT_INPROGRESS,
    image: {
      data: screenImage,
      mime_type: SCREEN_SHOT_MIME_TYPE
    },
    capture_timestamp: moment().format()
  };
  return JSON.stringify(requestData);
};

export const saveInitialQuestionsForm = data => ({
  type: SAVE_INITIAL_QUESTIONS_FORM,
  data,
  path: ROUTE_PERSONAL_INFO_PAGE
});

export const saveCheckIdentityForm = data => ({
  type: SAVE_CHECK_IDENTITY_FORM,
  data,
  path: '/initialQuestions'
});

export const saveSecurityChecksForm = data => ({
  type: SAVE_SECURITY_CHECKS_FORM,
  data,
  path: '/initialQuestions'
});

export const saveEnterLinkCodeForm = data => ({
  type: SAVE_ENTER_LINK_CODE_FORM,
  data,
  path: ROUTE_BEGIN_YOUR_APPLICATION_PAGE
});

export const savePersonalInformationForm = data => ({
  type: SAVE_PERSONAL_INFORMATION_FORM,
  data,
  meta: { nextAction: validatedNtbCustomerAndRedirect() }
});

export const saveBusinessTypeForm = data => ({
  type: SAVE_BUSINESS_TYPE_FORM,
  data,
  meta: { nextAction: validatedNtbCustomerAndRedirect(data) }
});

export const saveUsernamePasswordForm = data => ({
  type: SAVE_USERNAME_PASSWORD_FORM,
  data,
  meta: { nextAction: isExistingUser(data, createCustomerCase) }
});

export const redirectToAccountDetails = data => ({
  type: REDIRECT_TO_ACCOUNT_DETAILS,
  data,
  path: ROUTE_ACCOUNT_DETAILS_PAGE
});

export const redirectToPersonalInfo = data => ({
  type: 'personal_info',
  data,
  path: ROUTE_PERSONAL_INFO_PAGE
});

export const saveAboutYourForm = data => ({
  type: SAVE_ACCOUNT_DETAILS_PAGE,
  data,
  meta: {
    nextAction: updateAdditionalCase(null, ROUTE_ADDITIONAL_PRODUCT_PAGE)
  }
});

export const saveDetailsForm = data => ({
  type: SAVE_DETAILS_FORM,
  data
});

export const redirectToBusinessMandateProduct = () => ({
  type: REDIRECT_TO_BUSINESS_MANDATE_PAGE,
  path: ROUTE_BUSINESS_MANDATE_PAGE
});

export const saveAdditionalProductsForm = (data, isSoleTrader) => ({
  type: SAVE_ADDITIONAL_PRODUCTS_FORM,
  data,
  meta: {
    nextAction: updateAdditionalCase(
      null,
      isSoleTrader ? ROUTE_SIGNIFICANT_PEOPLE_PAGE : ROUTE_SIGNATORIES_AND_SHAREHOLDERS_PAGE
    )
  }
});

export const saveSignatoriesAndShareholdersForm = (values, applicantData) => ({
  type: SAVE_SIGNATORIES_AND_SHAREHOLDERS_FORM,
  values,
  meta: {
    nextAction: applicantData.officer_id
      ? updateOfficer(
          { officer: applicantData },
          applicantData.officer_id,
          ROUTE_SIGNIFICANT_PEOPLE_PAGE,
          'PRIMARY'
        )
      : addOfficer(applicantData, '', 'PRIMARY')
  }
});

export const updateSignatoriesAndShareholderInfo = data => ({
  type: SAVE_SIGNATORIES_AND_SHAREHOLDERS_FORM,
  data
});

export const saveSignificantPeopleForm = data => ({
  type: SAVE_SIGNIFICANT_PEOPLE_FORM,
  data,
  path: ROUTE_BUSINESS_MANDATE_PAGE
});

export const saveBusinessMandatePage = data => ({
  type: SAVE_BUSINESS_MANDATE_PAGE,
  data,
  meta: { nextAction: updateAdditionalCase(data) }
});

export const saveBusinessMandateForm = data => ({
  type: SAVE_BUSINESS_MANDATE_FORM,
  data
});

/**
 * Just for redirection
 */
export const routeToAdditionalProduct = () => ({
  type: REDIRECT_ADDITIONAL_PRODUCT_PAGE,
  path: ROUTE_ADDITIONAL_PRODUCT_PAGE
});

/**
 * Just for redirection
 */

export const routeToReviewPage = () => ({
  type: REDIRECT_ADDITIONAL_PRODUCT_PAGE,
  path: ROUTE_REVIEW_PAGE
});

/**
 * routeToImportantInfoPage
 */
export const routeToImportantInfoPage = () => ({
  type: NAVIGATE_TO_IMP_INFO,
  path: ROUTE_INFO_SECTION
});

export const saveBusinessDetailsAllForm = data => ({
  type: SAVE_REVIEW_SECTIONS_FORM,
  data
});

export const redirectToUsernamePasswordPage = data => ({
  type: SAVE_BUSINESS_TYPE_FORM,
  data,
  path: ROUTE_USERNAME_PASSWORD_PAGE
});

export const redirectToBusinessTypePage = data => ({
  type: NAVIGATE_TP_BUSINESSTYPE_ON_BACK,
  data,
  path: ROUTE_PERSONAL_INFO_PAGE
});

export const redirectToIDVQuestionPage = () => ({
  type: REDIRECT_IDV_QUESTION,
  path: ROUTE_IDV_QUESTION_PAGE
});

export const redirectToIDVCheck = () => ({
  type: 'CHECK_IDENTITY_PAGE',
  path: ROUTE_CHECK_IDENTITY_PAGE
});

export const redirectToCreditCheckNoMatch = () => ({
  type: 'credit_check_reffered_nomatch_page',
  path: ROUTE_CREDIT_CHECK_REFERRED_NO_MATCH_PAGE
});

export const redirectToDefferedPage = () => ({
  type: 'deffered_page',
  path: ROUTE_DEFERRED_PAGE
});

export const redirectToSetupInProgressPage = () => ({
  type: 'setUp_In_Progress',
  path: SET_UP_IN_PROGRESS_ERROR
});

export const redirectToPrimaryApplicantWaitingPage = () => ({
  type: 'primary_Applicant_Waiting',
  path: ROUTE_PRIMARY_APPLICANT_WAITING
});

export const redirectToSecondaryApplicantWaitingPage = () => ({
  type: 'secondary_Applicant_Waiting',
  path: ROUTE_SECONDARY_APPLICANT_WAITING
});

export const redirectToPendingStatement = () => ({
  type: 'pending_statment',
  path: ROUTE_PENDING_STATEMENTS_PAGE
});

export const redirectToPendingStatementFail = () => ({
  type: 'pending_statment_fail',
  path: ROUTE_PENDING_STATEMENTS_FAIL_PAGE
});

export const redirectToPersonalDetails = (data, navigation) => ({
  type: NAVIGATE_TO_CD,
  data,
  redirect: {
    to: NAVIGATE_TO_CD, //"BAA" , "source"
    navigation: navigation
  }
});

export const redirerctToAuthPage = data => ({
  type: REDIRECT_TOLETTER_CODE,
  data,
  path: LETTER_CODE
});

export const redirerctToIDVChallengeFail = () => ({
  type: 'idv_challenge_fail',
  path: ROUTE_TO_IDV_CHALLENGE_ERROR
});

export const saveInitialScreensInfo = data => ({
  type: SAVE_INITIAL_QUESTIONS_FORM,
  data
});

export const savePersonalInfo = data => ({
  type: SAVE_PERSONAL_INFORMATION_FORM,
  data
});

export const saveBusinessTypeInfo = data => ({
  type: SAVE_BUSINESS_TYPE_FORM,
  data
});

export const processSaveandResume = taskUri => ({
  type: 'task_uri_action_page_load',
  meta: redirectBasesOnTaskUri(taskUri)
});

/**
 * To make create customer case call
 */
export const createCustomerCase = (customer, publicKeyResponse, linkCode) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/current`,
    method: METHOD_POST,
    headers: {
      'x-bpi-version': API_VERSION
    },
    body: state => createCasePayload(state, customer, publicKeyResponse, linkCode),
    types: [
      {
        type: CREATE_CUSTOMERS_CASE,
        meta: {
          loading: true
        }
      },
      {
        type: CREATE_CUSTOMERS_CASE_SUCCESS,
        payload: (_action, _state, res) =>
          getJSON(res).then(json => {
            res.json = json;
            return json;
          }),
        meta: (_action, state, res) => ({
          nextAction:
            !res.json || !res.json.reference_id
              ? technicalErrorPage()
              : state.config.get(LINK_CODE_KEY)
              ? redirectToCustomerDetailsReview('', {
                  case_id: res.json.reference_id
                })
              : redirectToBusinessDetails({ case_id: res.json.reference_id }),
          loading: false
        })
      },
      {
        type: CREATE_CUSTOMERS_CASE_FAILED,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: (_action, state, res) => processCreateCaseError(res.json, state)
      }
    ]
  }
});

/**
 * To make update customer case call
 */
export const updateReviewCase = () => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/current/${getQueryStringValueByName(
      CASE_ID
    ) || getQueryStringValueByName(OFFER_CASE_ID)}/tasks/capture/actions/update`,
    method: METHOD_PUT,
    headers: {
      'x-bpi-version': API_VERSION
    },
    body: state => updateAdditonalPayload(state, ''),
    types: [
      {
        type: UPDATE_DETAILS_CASE,
        meta: {
          loading: true
        }
      },
      {
        type: UPDATE_DETAILS_CASE_SUCCESS,
        meta: (_action, state) => ({
          nextAction: caseSelector.getJointLinkCode(state)
            ? redirectToSignificantPeoplePage()
            : routeToImportantInfoPage(),
          loading: false
        })
      },
      {
        type: UPDATE_DETAILS_CASE_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

export const updateAdditionalCase = (customer, nextRoute) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/current/${getQueryStringValueByName(
      CASE_ID
    ) || getQueryStringValueByName(OFFER_CASE_ID)}/tasks/capture/actions/update`,
    method: METHOD_PUT,
    headers: {
      'x-bpi-version': API_VERSION
    },
    body: state => updateAdditonalPayload(state, customer),
    types: [
      {
        type: UPDATE_DETAILS_CASE,
        meta: {
          loading: true
        }
      },
      {
        type: UPDATE_DETAILS_CASE_SUCCESS,
        meta: {
          nextAction: nextRoute ? redirectToPage(nextRoute) : redirectToCustomerDetailsReview(),
          loading: false
        }
      },
      {
        type: UPDATE_DETAILS_CASE_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});
export const redirectToPage = path => ({
  type: REDIRECT_TO_PAGE,
  path
});

/**
 * Redirect to business details application
 */
export const redirectToBusinessDetails = (data, navigation) => ({
  type: NAVIGATE_TO_BD,
  data,
  redirect: {
    to: NAVIGATE_TO_BD,
    navigation: navigation
  }
});

export const onPaymentTypeCheckBoxChecked = data => ({
  type: PAYMENT_TYPE_CHECKBOX_CHECKED,
  data
});

/**
 * Redirect to business details application
 */
export const redirectToCustomerDetailsReview = (navigation, data) => ({
  type: NAVIGATE_TO_CD_REVIEW,
  data,
  redirect: {
    to: NAVIGATE_TO_CD_REVIEW, //"BAA" , "source"
    navigation: navigation,
    caseId: data && data.case_id ? data.case_id : '',
    linkCodeResume: data && data.linkCodeResume ? data.linkCodeResume : ''
  }
});

/**
 * Redirect to business details application review page
 */
export const redirectToBDDReviewScreen = (navigation, applicantFlow) => ({
  type: NAVIGATE_TO_BD_REVIEW,
  redirect: {
    to: NAVIGATE_TO_BD_REVIEW, //"BAA" , "source"
    navigation: navigation,
    applicantFlow: applicantFlow
  }
});

export const redirectToExit = () => ({
  type: NAVIGATE_TO_EXIT,
  redirect: {
    to: NAVIGATE_TO_EXIT
  }
});
/**
 * Redirect to business accounts application review page
 */
export const redirectToReviewPage = data => ({
  type: REDIRECT_TO_REVIEW_PAGE,
  data,
  path: ROUTE_REVIEW_PAGE
});

const validatedNtbCustomerAndRedirect = data => {
  const caseType = getQueryStringValueByName(CASE_SUBTYPE);
  if (caseType && caseType === CASE_TYPE_EXISTING) {
    return redirectToUsernamePasswordPage(data);
  } else if (caseType && caseType === CASE_TYPE_NTB) {
    return redirectToPersonalDetails(data);
  }

  return validateRouteToRedirect(ACCESS_TOKEN) && !validateRouteToRedirect(SAVE_AND_RESUME_CAPTURE)
    ? redirectToUsernamePasswordPage(data)
    : redirectToPersonalDetails(data);
};

/**
 * Need to call submitEvidence where need to send evidence call.
 */
export const submitEvidence = (data, subtype) => ({
  type: SAVE_EVIDENCE_TYPE_FORM,
  data,
  meta: {
    nextAction: takeScreenshot(data, subtype)
  }
});
/**
 * submitEvidence will call sendImageServiceCall to send image to service.
 * @param {*} data
 */
export const sendImageServiceCall = (data, subtype) => ({
  type: SUBMIT_IMAGE_SERVICE_CALL,
  data,
  meta: {
    nextAction: submitImageServiceCall(data, subtype)
  }
});
/**
 * submitEvidence function for important Info.
 * @param {*} data
 */
export const submitEvidenceCall = (data, subtype, info, isPrimaryEdit) => ({
  type: SAVE_EVIDENCE_TYPE_FORM,
  data,
  meta: {
    nextAction: takeScreenshot(data, subtype, info, isPrimaryEdit)
  }
});

/**
 * submitEvidence will call sendImageServiceCall to send image to service.
 * @param {*} data
 */
export const sendImageInfoServiceCall = (data, subtype, fromFlow, isPrimaryEdit) => ({
  type: SUBMIT_IMAGE_SERVICE_CALL,
  data,
  meta: {
    nextAction: submitImageInfoServiceCall(data, subtype, fromFlow, isPrimaryEdit)
  }
});

export const technicalErrorPage = data => ({
  type: ERROR_PAGE,
  data,
  path: ROUTE_TECH_ERROR
});

export const toggleLoading = data => ({
  type: TOGGLE_APP_LOADER,
  meta: {
    loading: data
  }
});

//updateCase for Info
export const updateCase = (isReview, fromFlow, isPrimaryEdit) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/current/${getQueryStringValueByName(
      CASE_ID
    ) || getQueryStringValueByName(OFFER_CASE_ID)}/tasks/capture/actions/update`,
    method: METHOD_PUT,
    headers: {
      'x-bpi-version': API_VERSION
    },
    body: state => JSON.stringify(updateCasePayload(state, '', isReview)),
    types: [
      {
        type: UPDATE_DETAILS_CASE,
        meta: {
          loading: isPrimaryEdit ? true : fromFlow === FROM_OFFER_FLOW
        }
      },
      {
        type: UPDATE_DETAILS_CASE_SUCCESS,
        meta: {
          nextAction: saveImportantInformationForm(fromFlow, isPrimaryEdit),
          loading: false
        }
      },
      {
        type: UPDATE_DETAILS_CASE_FAILED,
        meta: {
          nextAction: technicalErrorPage(),
          loading: false
        }
      }
    ]
  }
});

export const redirectToInitialPage = () => ({
  type: REDIRECT_TO_INITIAL_PAGE,
  path: ROUTE_INITIAL_QUESTION_PAGE
});

export const saveEnterAuthForm = () => ({
  type: SAVE_ENTER_AUTH_FORM,
  path: OFFER_PAGE
});

export const saveOpenBusinessAccountForm = data => ({
  type: SAVE_OPEN_BUSINESS_ACCOUNT_FORM,
  data,
  path: '/openAlternateBusinessAccount'
});

export const saveAltBusinessAccountForm = data => ({
  type: SAVE_ALT_BUSINESS_ACCOUNT_FORM,
  data,
  path: '/decline'
});

export const redirectToDeclinePage = () => ({
  type: REDIRECT_TO_DECLINE_PAGE,
  path: DECLINE
});

export const redirectToAddShareholderPage = () => ({
  type: REDIRECT_ADD_SHAREHOLDER,
  path: ROUTE_PERSONAL_DETAILS_PAGE
});

export const getExistingUser = () => ({
  [RSAA]: {
    endpoint: `:api_paas_url/user`,
    method: 'GET',
    headers: {
      'x-bpi-version': '0.8.0',
      'x-bpi-service-context': 'USER'
    },
    types: [
      {
        type: FETCH_USER,
        meta: {
          loading: true
        }
      },
      {
        type: FETCH_USER_SUCCESS,
        payload: (_action, _state, res) =>
          getJSON(res).then(json => {
            res.json = json;
            return json;
          }),
        meta: {
          loading: false
        }
      },
      {
        type: FETCH_USER_FAILED,
        meta: {
          loading: false
        }
      }
    ]
  }
});

export const getOffers = () => ({
  type: GET_OFFERS_CALL,
  meta: {
    nextAction: retrieveOffers()
  }
});

export const requestLinkCodeScreen = () => ({
  type: REQUEST_LINK_CODE_SCREEN,
  path: ROUTE_TO_INCORRECT_LINK_CODE
});

export const redirectToEnterLinkCodePage = () => ({
  type: REDIRECT_TO_LINK_CODE,
  path: ROUTE_ENTER_LINK_CODE
});

export const redirectToDocumentVersionPage = () => ({
  type: REDIRECT_TO_DOC_VERSION_PAGE,
  path: ROUTE_DOCUMENT_VERSION_PAGE
});

export const validatedLinkCodeAndRedirect = (linkCode, customer) => ({
  type: SAVE_ENTER_LINK_CODE_FORM,
  linkCode,
  meta: {
    nextAction: isExistingUser(customer, createCustomerCase, linkCode.link_code)
  }
});

const isExistingUser = (data, callback, linkCode) => {
  const case_id = getQueryStringValueByName(CASE_ID) || getQueryStringValueByName(OFFER_CASE_ID);
  const lCode = linkCode ? linkCode : getQueryStringValueByName(LINK_CODE_KEY);
  if (case_id && lCode) {
    return redirectToCustomerDetailsReview('', { case_id: case_id });
  } else if (case_id) {
    return redirectToBusinessDetails({ case_id: case_id });
  }
  return callback(data, '', linkCode);
};

const getCaseId = () =>
  getQueryStringValueByName(CASE_ID) || getQueryStringValueByName(OFFER_CASE_ID);

const getErrorMessageUrl = (state, code) => {
  const configAppUrls = state.config.toJS();
  const brandId = state.config.get(BRAND_ID);
  if (code === ERROR_CODE_325) {
    const businessAccountsUrl = encodeURIComponent(
      `${configAppUrls.businessAccountsUrl}?type=resume`
    );
    return `${configAppUrls.authenticationUrl}/${brandId}?client_id=vmbaa_web&response_type=token&redirect_uri=${businessAccountsUrl}`;
  } else if (code === ERROR_CODE_326) {
    const businessAccountsUrl = configAppUrls.businessAccountsUrl;
    return `${configAppUrls.authenticationUrl}/${brandId}?client_id=vmbaa_web&response_type=token&redirect_uri=${businessAccountsUrl}`;
  }
  return '';
};

const getMetaForCreateCaseError = (state, res) => ({
  url: getErrorMessageUrl(state, res.error.code),
  errorCode: res.error.code,
  content: state.content,
  loading: false
});

const processCreateCaseError = (res, state) => {
  if (res.error.code === '319') {
    return {
      nextAction: requestLinkCodeScreen(),
      loading: false,
      errorCode: res.error.code,
      content: state.content
    };
  }
  return !ERROR_CODES[res.error.code]
    ? { nextAction: technicalErrorPage(), loading: false }
    : getMetaForCreateCaseError(state, res);
};

const checkForOfferFLow = (fromFlow, isPrimaryEdit) => {
  if (fromFlow === FROM_CAS_FLOW) {
    return {
      nextAction: redirectToPage(ROUTE_APPLICATION_COMPLETE_PAGE),
      loading: false
    };
  } else if (fromFlow !== FROM_OFFER_FLOW) {
    return {
      nextAction: updateCase(true, fromFlow, isPrimaryEdit),
      loading: false
    };
  }
  return { nextAction: getNextCall(false), loading: true };
};

export const onAccountDetailsChange = data => ({
  type: ON_ACCOUNT_DETAILS_CHANGE,
  data
});

export const onCountryRemove = data => ({
  type: ON_COUNTRY_REMOMVE,
  data
});

export const resetLinkCodeError = () => ({
  type: RESET_LINK_CODE_ERROR
});

export const callGetNext = error => ({
  type: REDIRECT_ERROR_PAGE,
  error,
  meta: {
    nextAction: error && error.id === 1 ? getNextCall(false) : technicalErrorPage()
  }
});

export const redirectToPreviousPage = backPath => ({
  type: REDIRECT_TO_INITIAL_PAGE,
  path: backPath
});

export const redirectToPreviousRoute = pathname => (dispatch, getState) => {
  const state = getState();
  const backPath = getBackNavigationRoute(pathname, state);
  const caseId = state.config.get(CASE_ID);
  if (backPath) {
    if (backPath === NAVIGATE_TO_CD) {
      return dispatch(redirectToPersonalDetails('', NAVIGATION_BACK));
    }
    if (backPath === NAVIGATE_TO_BD) {
      return dispatch(redirectToBusinessDetails({ case_id: caseId }, NAVIGATION_BACK));
    }
    if (backPath === NAVIGATE_TO_BD_REVIEW) {
      return dispatch(
        redirectToBDDReviewScreen(NAVIGATION_BACK, getQueryStringValueByName(APPLICANT_FLOW))
      );
    }
    if (backPath === ROUTE_SWITCH_DATE_PAGE) {
      dispatch(resetConfirmSwitchError());
    }
    return dispatch(redirectToPreviousPage(backPath));
  }
};
